export default {"src":"/_next/static/media/Restaurant.917da0c0.svg","height":570,"width":1272,"blurWidth":0,"blurHeight":0};